import React from "react"
import { motion } from "framer-motion"
import {
  FaSpa,
  FaHotTub,
  FaLeaf,
  FaHands,
  FaSwimmingPool,
} from "react-icons/fa"

import SectionTitle from "../common/SectionTitle"
import Button from "../common/Button"

export default function ServicesPreview() {
  const services = [
    {
      id: 1,
      title: "Massage Relaxant",
      description:
        "Massages professionnels conçus pour libérer les tensions et rétablir l'équilibre.",
      icon: <FaHands />,
      image: "/images/service-massage.jpg",
    },

    {
      id: 2,
      title: "Soins du visage",
      description:
        "Soins du visage revitalisants utilisant des produits et des techniques de soins de la peau haut de gamme.",
      icon: <FaLeaf />,
      image: "/images/service-facial.jpg",
    },

    {
      id: 3,
      title: "Beauté des Mains & Pieds",
      description:
        "Expériences de bien-être de luxe axées sur la régénération du corps et la sérénité.",
      icon: <FaSpa />,
      image: "/images/service-onglerie.jpg",
    },
        {
      id: 4,
      title: "Installations Bien-Être",
      description:
        "Profitez de notre piscine intérieure chauffée, hammam traditionnel, salle de remise en forme et espaces de détente.",
      icon: <FaSwimmingPool />,
      image: "/images/pool.jpg",
      
    },
  ]

  return (
    <section className="py-20 lg:py-28 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Title */}
        <SectionTitle
          subtitle="Nos Services"
          title="Des Soins de Luxe conçus pour votre Bien-être"
          description="Découvrez des soins spa haut de gamme et des rituels de bien-être conçus pour vous aider à vous détendre, à vous ressourcer et à vous sentir au mieux de votre forme."
        />

        {/* Services Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 mt-16">
          {services.map((service, index) => (
            <motion.article
              key={service.id}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              viewport={{ once: true }}
              className="group bg-white rounded-[28px] overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500"
            >
              {/* Image */}
              <div className="relative overflow-hidden h-72">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition duration-700"
                  loading="lazy"
                />

                {/* Overlay */}
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/35 transition duration-500" />

                {/* Icon */}
                <div className="absolute top-5 left-5 w-14 h-14 rounded-full bg-white text-[#b8955d] text-2xl flex items-center justify-center shadow-lg">
                  {service.icon}
                </div>
              </div>

              {/* Content */}
              <div className="p-7">
                <h3 className="text-2xl font-semibold text-[#111111] mb-4">
                  {service.title}
                </h3>

                <p className="text-gray-600 leading-relaxed text-sm">
                  {service.description}
                </p>

                {/* Button */}
                <div className="mt-6">
                  <Button
                    to="/services"
                    variant="secondary"
                    size="sm"
                    ariaLabel={`Explore ${service.title}`}
                  >
                    En Savoir Plus
                  </Button>
                </div>
              </div>
            </motion.article>
          ))}
        </div>

        {/* Bottom CTA */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="mt-16 text-center"
        >
          <Button
            to="/services"
            size="lg"
            variant="primary"
            ariaLabel="Voir tous les services de spa"
          >
            Voir Tout Les Services
          </Button>
        </motion.div>
      </div>
    </section>
  )
}